// extracted by mini-css-extract-plugin
export default {"header":"src-client-modal-components-ModalHeader-___default__header___oIyNQ","root":"src-client-modal-components-ModalHeader-___default__root___cN9l0"};